var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPackageType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "29px",
    viewBox: "0 0 31 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D8F1325E-1236-40D3-9ADB-D261009F8C65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-138.000000, -1119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "type-package",
    transform: "translate(139.000000, 1120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paka",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 9,
    width: 27,
    height: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    points: "0.6 8.84140625 8.41176758 0.9 17.2364746 0.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    transform: "translate(20.118237, 4.870703) scale(-1, 1) translate(-20.118237, -4.870703) ",
    points: "11.8 8.84140625 19.6117676 0.9 28.4364746 0.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7319336,1 L14.7319336,8.39160156",
    id: "Path-57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.972,15.814 C17.972,17.522 16.866,18.488 14.738,19.132 L14.696,19.622 L13.17,19.958 L12.988,17.732 L13.548,17.578 C15.116,17.144 15.634,16.71 15.634,16.01 C15.634,15.394 15.116,15.03 14.262,15.03 C13.24,15.03 12.204,15.478 11.308,16.08 L11,14.022 C11.91,13.434 13.044,13 14.556,13 C16.698,13 17.972,14.036 17.972,15.814 Z M15.074,23.332 L12.694,23.332 L12.694,20.812 L15.074,20.812 L15.074,23.332 Z",
    id: "?",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPackageType);
export default __webpack_public_path__ + "static/media/ico_package-type.5cc58da9ff88572fd87c0880644e68f7.svg";
export { ForwardRef as ReactComponent };